import { createCRUDHook } from './createCRUDHook';
import { DraftPartManufacturerDto } from 'utils/models';
import { TBL_DRAFT_PART_MULTIPLIER } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<DraftPartManufacturerDto>({
    entityName: 'DraftPartManufacturer',
    endpoint: TBL_DRAFT_PART_MULTIPLIER,
  });

export const DraftPartManufacturerContext = Context;
export const useDraftPartManufacturerManager = useManager;
export const useDraftPartManufacturer = useConsumer;
